<st-story-full-screen
    [autoUpdate]="autoUpdate()"
    [standaloneStory]="standaloneStory()"
    [loaderState]="loaderState()"
    [parentTopic]="parentTopic()"
    [data]="currentStory()"
    [disabled]="isStoryDisabled()"
    (backToTopic)="backToTopic()"
    (promptSelected)="createNewStoryVersion($event)"
    (mosMediaClicked)="onMosMediaClicked($event)" />
@if (isCurrentRecordNew()) {
    <div class="st-stories-full-screen-create-footer">
        <mat-divider />
        <div class="st-stories-full-screen-create-footer-buttons">
            <button
                mat-button
                matRipple
                [disabled]="disabled()"
                [matRippleRadius]="15"
                (click)="create(false)">
                @if (!loading()) {
                    {{ languageSettings.PSTWebSaveAndCloseButtonLabel }}
                } @else {
                    <st-loader
                        class="st-stories-full-screen-create-footer-buttons--spinner"
                        [diameter]="30"
                        [strokeWidth]="5" />
                }
            </button>
            <button
                mat-button
                color="primary"
                [disabled]="disabled()"
                (click)="create(true)">
                @if (!loadingSaveAndNext()) {
                    {{ languageSettings.PSTWebSaveAndContinueButtonLabel }}
                } @else {
                    <st-loader
                        class="st-stories-full-screen-create-footer-buttons--spinner"
                        [diameter]="30"
                        [strokeWidth]="5" />
                }
            </button>
        </div>
    </div>
}
